import React from "react";
import { withRouter } from "react-router-dom";
import { Form, Input, Row, Col, Button, Modal, message } from "antd";
import socket from "util/socket";
import rsaWrapper from "util/rsa-wrapper";
import aesWrapper from "util/aes-wrapper";
import converterWrapper from "util/converterWrapper";
import UserModel from "../../../profile/model";
const cookie = require("js-cookie");
// import UserModel from "../model";
class Settings extends React.PureComponent {
  state = {
    _id: 0,
    prevId: 0,
    loader: false,
    onClickButton: true,
    connection: false,
  };
  componentWillMount() {
    message.destroy();
    this.socketConnect();
  }
  socketConnect() {
    socket.connect();
    const completeSecureConnection = (secretKey) => {
      this.AESKey = secretKey;
      this.setState({ connection: true });

      const fingerprint = btoa(navigator.userAgent);
      cookie.set("fngprt", fingerprint, {
        secure: process.env.NODE_ENV !== "dev",
        sameSite: "Strict",
      });
    };

    const runLegacyHandshake = (serverKey) => {
      socket
        .emit("SECRET_KEY")
        .then((ackResponse) => {
          const directKey =
            ackResponse &&
            ackResponse.data &&
            typeof ackResponse.data._data === "string"
              ? ackResponse.data._data
              : null;

          if (directKey) {
            completeSecureConnection(directKey);
            return;
          }

          socket.on("SECRET_KEY", (key) => {
            rsaWrapper
              .privateDecrypt(serverKey, key)
              .then((secretKey) => {
                completeSecureConnection(secretKey);
              })
              .catch((err) => {
                console.log("error occurred ", err.name);
                console.log("error occurred code ", err.code);
              });
          });
        })
        .catch((err) => {
          console.log("error occurred ", err.name);
          console.log("error occurred code ", err.code);
        });
    };

    const extractServerKey = (payload) => {
      if (!payload) return null;

      const pickFromObject = (obj) =>
        obj &&
        (obj.publicKey ||
          obj.clientPublicKey ||
          obj.key ||
          obj.privateKey ||
          obj.clientPrivateKey ||
          obj.data);

      if (typeof payload === "object") {
        return pickFromObject(payload);
      }

      if (typeof payload !== "string") {
        return null;
      }

      const raw = payload.trim();

      if (raw.indexOf("BEGIN ") > -1 || /^[A-Za-z0-9+/=_-]+$/.test(raw)) {
        return raw;
      }

      try {
        const parsed = JSON.parse(raw);
        if (typeof parsed === "string") {
          return parsed;
        }
        return pickFromObject(parsed) || raw;
      } catch (e) {
        const match = raw.match(
          /"(?:publicKey|clientPublicKey|key|privateKey|clientPrivateKey|data)"\s*:\s*"([^"]+)"/
        );
        if (match && match[1]) {
          return match[1].replace(/\\n/g, "\n");
        }
      }

      return raw;
    };

    socket.on("CLIENT_PRIVATE_KEY", (serverKeyResponse) => {
      const serverKey = extractServerKey(serverKeyResponse);

      if (!serverKey) {
        return;
      }

      const secretKeyBytes = window.crypto.getRandomValues(new Uint8Array(16));
      const secretKey = converterWrapper.arrayBufferToBase64String(secretKeyBytes.buffer);

      rsaWrapper
        .publicEncrypt(serverKey, secretKey)
        .then((encryptedSecretKey) => socket.emit("SECRET_KEY", encryptedSecretKey))
        .then((ackResponse) => {
          const directKey =
            ackResponse &&
            ackResponse.data &&
            typeof ackResponse.data._data === "string"
              ? ackResponse.data._data
              : null;

          completeSecureConnection(directKey || secretKey);
        })
        .catch(() => {
          runLegacyHandshake(serverKey);
        });
    });
  }
  handleSubmitRePassword = e => {
    this.setState({ loader: true, onClickButton: false });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // Dynamically import captchaV3
        const RecaptchaV3 = require("../../../../util/captchaV3");
        RecaptchaV3.execute("reset_password").then((captchaToken) => {
          var objectValues = {};
          // AES key is only available in memory via socketConnect(); never read from localStorage
          var AESKey = this.AESKey;
          if (!AESKey) {
            this.setState({ loader: false, onClickButton: true });
            message.error("Secure connection not established. Please refresh the page.");
            return;
          }
          aesWrapper.encryptMessage(AESKey, values.oldPassword).then(encryptedPassword => {
            objectValues["oldPassword"] = encryptedPassword;
            aesWrapper.encryptMessage(AESKey, values.newPassword).then(encryptedNewPassword => {
              objectValues["newPassword"] = encryptedNewPassword;
              objectValues["recaptchaToken"] = captchaToken;
              this.setState({ loader: true });
              UserModel.userTraineePasswordReset(objectValues).then(response => {
                this.setState({ loader: false, onClickButton: true });
                if (response && response.status === 200) {
                  // Show success message
                  message.success("Password reset successfully.");

                  // Ask confirmation for logout
                  Modal.confirm({
                    title: "Log In Again",
                    content: "Your password has been changed successfully. Please log in again.",
                    okText: "Yes, log in again",
                    cancelText: "Stay here",
                    okButtonProps: { type: "primary" }, // Blue primary for "Yes"
                    cancelButtonProps: { type: "primary" }, // Normal styled button for "Stay"
                    onOk() {
                      //show mesage false
                      UserModel.logout(false).then(() => {
                        localStorage.clear();
                        window.location = "/login";
                      });
                    },
                    onCancel() {
                      message.info("You stayed logged in.");
                    },
                  });
                } else {
                  // Show error message if not 200
                  message.error(response.userMessage || "Password reset failed.");
                }
              });
            });
          });
        }).catch(() => {
          this.setState({ loader: false, onClickButton: true });
          message.error("Captcha validation failed. Please try again.");
        });
      } else {
        this.setState({ loader: false, onClickButton: true });
      }
    });
  };
  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("Password mismatch");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]{8,16}$/;
    if (form.getFieldValue("newPassword")) {
      if (!regularExpression.test(value)) {
        callback(
          "Password must be 8–16 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character"
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  render() {
    const { loader } = this.state;

    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      style: { lineHeight: 28 },
      labelAlign: "left",
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <div
        className="uk-card-default uk-card-hover  uk-card-small Course-card uk-inline-clip uk-transition-toggle"
        tabindex="0"
      >
        <div className="reset-password-top text-center">
          <h3 className="panel-title text-center">
            {/* <i className="fa fa-custom-reset-password"></i> */}
            <img src={require("assets/images/reset_password_icon.png")}></img>
            {"Reset Password"}
          </h3>
          <img src={require("assets/images/reset_password_image.png")}></img>
        </div>

        <div className="panel-body">
          <div id="custom-ant-input">
            <Form {...formItemLayout} onSubmit={this.handleSubmitRePassword} style={{ margin: 20 }}>
              <Row>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Form.Item label="Old Password">
                    {getFieldDecorator("oldPassword", {
                      rules: [
                        {
                          required: true,
                          pattern: /^[a-zA-Z0-9_\-,]/,
                          message: "Please input Old Password!",
                        },
                      ],
                    })(<Input type="password" placeholder={`Old Password`} />)}
                  </Form.Item>
                  <Form.Item label="New Password">
                    {getFieldDecorator("newPassword", {
                      rules: [
                        {
                          required: true,
                          // pattern: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[0-9]).{4,}$/,
                          message: "Please input new password!",
                        },
                        {
                          validator: this.validateToNextPassword,
                        },
                      ],
                    })(<Input type="password" onPressEnter={this.handleOk} placeholder={`New Password`} />)}
                  </Form.Item>
                  <Form.Item label="Confirm Password">
                    {getFieldDecorator("confirmPassword", {
                      rules: [
                        {
                          required: true,
                          message: "Please input confirm password!",
                        },
                        {
                          validator: this.compareToFirstPassword,
                        },
                      ],
                    })(
                      <Input
                        onBlur={this.handleConfirmBlur}
                        type="password"
                        onPressEnter={this.handleOk}
                        placeholder={`Confirm Password`}
                      />
                    )}
                  </Form.Item>
                  <div className=" uk-text-center uk-margin">
                    <Form.Item style={{ marginTop: "78px" }}>
                      {" "}
                      <Button type="info" htmlType="submit" disabled={!this.state.connection || !this.state.onClickButton}>
                        Reset
                      </Button>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Form.create()(withRouter(Settings));
// export default withRouter(MainView) ;
